export default {
  model: {
    'options/style': '装修风格',
    'options/space': '空间',
    'options/color': '颜色',
    'options/light': '灯光',
    'options/material': '材质',
    'options/custom': '自定义',
    'role': '角色',
    'activeStorage/attachment': 'Attachment',
    'application': '应用管理',
    'adminUsersRole': '管理员',
    'adminUser': '管理员',
    'banner': '轮播图',
    'profile': 'Profile',
    'user': '用户',
    'activeStorage/blob': '资源',
    'actsAsTaggableOn/tag': '标签',
    'page': '静态页面',
    'presetPage': '静态页面',
    'staticPage': '静态页面',
    'customPage': '自定义页面',
    'hotWord': '搜索热词',
    'operationRecord': '操作日志',
    'option': '选项',
    'image': '图片生成',
    'sampleImage': '示例图',
    'roleCore/role': '角色',
  },
  'options/style': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'options/space': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'options/color': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'options/light': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'options/material': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'options/custom': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    kinds: {
      super: 'Super',
      application: '应用管理',
      custom: 'Custom',
    },
    customPermissions: '自定义权限',
  },
  'activeStorage/attachment': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: 'Content type',
    filename: 'Filename',
    byteSize: 'Byte size',
    url: 'Url',
  },
  'application': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    desc: '描述',
    shareDesc: '分享描述',
    shareTitle: '分享标题',
    wechatApplicationId: 'Wechat application',
    applicationAdminUsersRoleId: 'Application admin users role',
    shareImage: '分享图片',
    logo: 'Logo',
    imageGenerateOptions: '生图选项',
    creator: 'Creator',
    posterImage: '海报图片',
    loginVideo: '登录视频',
  },
  'adminUsersRole': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    roleId: '角色',
    adminUserId: 'Admin user',
    applicationId: '应用ID',
    isBlock: '已冻结',
    role: '角色',
    application: '应用管理',
    adminUser: '管理员',
    adminUserAttributes: 'Admin user attributes',
  },
  'adminUser': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    email: '邮箱',
    name: '姓名',
    isBlock: '已冻结',
    adminUsersRolesAttributes: 'Admin users roles attributes',
  },
  'banner': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    target: '目标',
    position: '优先级',
    pagePosition: '页面位置',
    pagePositions: {
      index_top: '首页',
    },
    kind: '类型',
    kinds: {
      web_link: '网站链接',
      image: '纯图片',
      mp_link: '小程序链接',
      external_mp_link: '外部小程序链接',
    },
    alt: '图片描述',
    image: '图片',
  },
  'profile': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    email: '邮箱',
    phone: '手机号码',
    gender: '性别',
    genders: {
      unknown: '未知',
      male: '男',
      female: '女',
    },
  },
  'user': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    screenName: '名称',
    isBlock: '已冻结',
    profile: 'Profile',
    avatar: '头像',
  },
  'activeStorage/blob': {
    id: 'ID',
    createdAt: '创建时间',
    signedId: 'Signed',
    contentType: '类型',
    filename: '文件名',
    byteSize: 'Byte size',
    url: '内容',
    tagList: 'Tag list',
  },
  'actsAsTaggableOn/tag': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
  },
  'page': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    slug: 'Slug',
    title: '标题',
    type: '类型',
    applicationId: '应用ID',
    viewsCount: '浏览数',
    publishedAt: '发布时间',
    wxacode: '小程序码',
    content: '内容',
  },
  'presetPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    viewsCount: '浏览数',
    content: '内容',
  },
  'staticPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    status: '状态',
    viewsCount: '浏览数',
    wxacode: '小程序码',
    content: '内容',
  },
  'customPage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    slug: 'Slug',
    default: '预置页面',
    miniProgramPath: '小程序路径',
    publishedAt: '最后发布时间',
    formalCustomPageId: 'Formal custom page',
    formalCustomPage: 'Formal custom page',
    canRollbackData: 'Can rollback data',
    configs: '自定义页面',
  },
  'hotWord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    applicationId: '应用ID',
    application: '应用管理',
  },
  'operationRecord': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    operatableType: '操作对象类型',
    operatableId: '操作对象ID',
    operatorType: 'Operator type',
    operatorId: 'Operator',
    ipAddress: 'IP地址',
    operator: '操作者',
    operatable: '操作对象',
    operationDescription: '操作描述',
    requestPath: '请求路径',
    requestMethod: '请求方法',
    requestParams: '请求数据',
    previousObject: 'Previous object',
    currentObject: 'Current object',
  },
  'option': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    type: 'Type',
    name: '名称',
    position: '优先级',
    prompt: '提示词',
    guidanceScale: '引导强度',
    negativePrompt: '负向描述',
    cover: '封面',
    creator: '创建者',
  },
  'image': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    title: '标题',
    failMessage: '失败信息',
    taskId: 'Task',
    state: '状态',
    states: {
      pending: '待处理',
      completed: '已完成',
      failed: '处理失败',
    },
    userId: 'User',
    raw: '用户上传图片',
    origin: '原图',
    results: '生成结果',
    user: '用户',
    options: '生成选项',
  },
  'sampleImage': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    position: '优先级',
    image: '图片',
  },
  'roleCore/role': {
    id: 'ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    name: '名称',
    kind: '类型',
    customPermissions: 'Custom permissions',
  },
}
